import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "badge", "modalSource"]

  switchState(event) {
    event.preventDefault()
    const state = event.currentTarget.dataset.state

    // Update active tab
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("btn-5", tab.dataset.state === state)
      tab.classList.toggle("btn-outline-secondary", tab.dataset.state !== state)
    })

    // Update badge
    if (state === "off") {
      this.badgeTarget.classList.add("d-none")
    } else {
      this.badgeTarget.classList.remove("d-none")
      this.badgeTarget.textContent = state === "100" ? "Previewing limit reached" : `Previewing ${state}% usage`
    }

    // Toggle panels
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("d-none", panel.dataset.state !== state)
    })

    // Swap send button for upgrade button at 100%, restore otherwise
    this.toggleSendButton(state === "100")

    // For 100% state, open the modal
    if (state === "100") {
      this.openUpgradeModal()
    }
  }

  openUpgradeModal() {
    // Try the persistent modal first (used by 70/90/100%)
    var modal = document.getElementById("dailyLimitUpgradeModal")
    if (modal && typeof $ !== "undefined") {
      $(modal).modal("show")
      return
    }

    // Fallback to template-based modal
    const modalFrame = document.getElementById("modal_frame")
    if (!modalFrame || !this.hasModalSourceTarget) return

    modalFrame.innerHTML = this.modalSourceTarget.innerHTML

    const modalEl = modalFrame.querySelector(".modal")
    if (modalEl && typeof $ !== "undefined") {
      $(modalEl).modal("show")
      $(modalEl).on("hidden.bs.modal", () => {
        modalEl.remove()
      })
    }
  }

  toggleSendButton(showUpgrade) {
    const sendButton = document.getElementById("send-button")
    if (!sendButton) return

    if (showUpgrade) {
      // Store original content for restoration
      if (!this._originalSendHTML) {
        this._originalSendHTML = sendButton.innerHTML
      }
      sendButton.innerHTML = '<button class="btn btn-5 btn-md" data-toggle="modal" data-target="#dailyLimitUpgradeModal" type="button"><span class="fas fa-bolt mr-1"></span>Upgrade</button>'
    } else if (this._originalSendHTML) {
      sendButton.innerHTML = this._originalSendHTML
    }
  }
}
